import { useQueryClient } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'
import PageLayout from '@/components/layout/page-layout'
import { Button } from '@/components/ui/button'
import { useFirebaseUser } from '@/hooks/useFirebaseUser'

export const Route = createFileRoute('/_authenticated/(developer)/debug')({
  component: DebugPage,
})

function DebugPage() {
  const { reloadUser } = useFirebaseUser()
  const queryClient = useQueryClient()

  return (
    <PageLayout title="Debug">
      <div className="card flex flex-col gap-8 [&_>_div]:space-y-2">
        <div>
          <Button onClick={reloadUser} size="lg">
            Reload user
          </Button>
          <p>Reloads user claims and tokens, may fix auth issues.</p>
        </div>
        <div>
          <Button onClick={() => queryClient.invalidateQueries()} size="lg">
            Reload data
          </Button>
          <p>Reloads all queries in the React Query client, may fix stale data issues.</p>
        </div>
      </div>
    </PageLayout>
  )
}
